import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/

// --- Public routes (no auth required) ---
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/choose-branch',
    name: 'ChooseBranch',
    component: () => import('@/views/login/branches.vue'),
    hidden: true,
    meta: { title: 'Choose Branch'}
  },
  // {
  //   path: '/merchant-grn',
  //   component: Layout,
  //   redirect: '',
  //   children: [
  //     {
  //         path: 'merchant-grn',
  //         name: 'စာရင်း',
  //         redirect: '',
  //         component: () => import('@/views/merchant/merchant_grn.vue'),
  //         meta: { title: 'စာရင်း', icon: 'product-list' },
  //         hidden: true
  //     },  
  //   ]
  // }
  
]

// --- Protected (dynamic) routes loaded after login ---
export const adminRouterMap = [
  {
    path: '/admin',
    component: Layout,
    redirect: '',
    children: [
      {
        path: '',
        name: 'GRN Report',
        component: () => import('@/views/admin/grn_report.vue'),
        meta: { title: 'GRN Report', icon: 'product-list' },
      },
      {
        path: 'gates',
        name: 'gates',
        component: () => import('@/views/admin/gate.vue'),
        meta: { title: 'Gates', icon: 'product-list' },
      },
      {
        path: 'cars',
        name: 'cars',
        component: () => import('@/views/admin/car.vue'),
        meta: { title: 'Cars', icon: 'product-list' },
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('@/views/admin/role.vue'),
        meta: { title: 'Roles', icon: 'product-list' },
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('@/views/admin/user.vue'),
        meta: { title: 'Users', icon: 'product-list' },
      },
      {
        path: 'drivers',
        name: 'drivers',
        component: () => import('@/views/admin/driver.vue'),
        meta: { title: 'Drivers', icon: 'product-list' },
      },
      
    ]
  },
  
];

export const asyncRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '',
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: 'Dashboard', icon: 'product-list' },
      },
      {
        path: 'merchant',
        name: 'ကုန်သည်စာရင်း',
        component: () => import('@/views/merchant/index.vue'),
        meta: { title: 'ကုန်သည်စာရင်း', icon: 'product-list' },
      },
      {
        path: 'merchant-grn',
        name: 'စာရင်း',
        component: () => import('@/views/merchant/merchant_grn.vue'),
        meta: { title: 'စာရင်း', icon: 'product-list' },
        hidden: true
      }, 
      {
        path: 'grn',
        name: 'ကုန်လက်ခံဘောက်ချာ',
        component: () => import('@/views/grn/index.vue'),
        meta: { title: 'ကုန်လက်ခံဘောက်ချာ', icon: 'product-list' }
      },
      {
        path: 'grn-ledger',
        name: 'ကုန်လက်ခံလယ်ဂျာ',
        component: () => import('@/views/grn_ledger/index.vue'),
        meta: { title: 'ကုန်လက်ခံလယ်ဂျာ', icon: 'product-list' }
      },
      {
        path: 'car-upload',
        name: 'ကုန်တင်',
        component: () => import('@/views/car_upload/index.vue'),
        meta: { title: 'ကုန်တင်', icon: 'product-list' }
      },
      {
        path: 'car-lane',
        name: 'ကားကြီးလမ်းပြ',
        component: () => import('@/views/car_lane/index.vue'),
        meta: { title: 'ကားကြီးလမ်းပြ', icon: 'product-list' }
      },
      {
        path: 'grn-payment',
        name: 'ငွေတောင်းဘောက်ချာ',
        component: () => import('@/views/money_request/index.vue'),
        meta: { title: 'ငွေတောင်းဘောက်ချာ', icon: 'product-list' }
      },
      {
        path: 'cash-summary',
        name: 'ငွေပေါင်းချုပ်',
        component: () => import('@/views/cash_summary/index.vue'),
        meta: { title: 'ငွေပေါင်းချုပ်', icon: 'product-list' }
      },
      {
        path: 'grn-income',
        name: 'နေ့စဉ်ငွေအဝင်',
        component: () => import('@/views/daily_income/index.vue'),
        meta: { title: 'နေ့စဉ်ငွေအဝင်', icon: 'product-list' }
      },
      {
        path: 'daily-income-expense',
        name: 'နေ့စဉ်အသုံးစရိတ်ငွေဝင်/ထွက်',
        component: () => import('@/views/daily_income_expense/index.vue'),
        meta: { title: 'နေ့စဉ်အသုံးစရိတ်ငွေဝင်/ထွက်', icon: 'product-list' }
      },
       {
        path: 'monthly-income-expense',
        name: 'လချုပ်ရှင်းတမ်း',
        component: () => import('@/views/ie_summary/index.vue'),
        meta: { title: 'လချုပ်ရှင်းတမ်း', icon: 'product-list' }
      },
      {
        path: 'grn-credit',
        name: 'Paid အကြွေး',
        component: () => import('@/views/paid_credit/index.vue'),
        meta: { title: 'Paid အကြွေး', icon: 'product-list' }
      },
      {
        path: 'driver-debt',
        name: 'ကားဆရာအကြွေး',
        component: () => import('@/views/driver_debt/index.vue'),
        meta: { title: 'ကားဆရာအကြွေး', icon: 'product-list' }
      },
       {
        path: 'mini-truck-goods-down',
        name: 'ခေါက်တိုကုန်ချ',
        component: () => import('@/views/minitruck_expenditure/index.vue'),
        meta: { title: 'ခေါက်တိုကုန်ချ', icon: 'product-list' }
      },
      {
        path: 'mini-truck-staffs',
        name: 'ခေါက်တိုဝင်/ထွက်ငွေပြုပြင်',
        component: () => import('@/views/minitruck_iem/index.vue'),
        meta: { title: 'ခေါက်တိုဝင်/ထွက်ငွေပြုပြင်', icon: 'product-list' }
      },
      {
        path: 'cars',
        name: 'cars',
        component: () => import('@/views/admin/car.vue'),
        meta: { title: 'Cars', icon: 'product-list' },
      },
    ]
  },
]

export default new Router({
  mode: 'history', // ✅ removes the #
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

